// Every URL below was fetched and verified (HTTP 200 + image content-type) directly from each
// league's own official domain, except NPB which is Wikimedia's Public Domain-licensed file
// (ineligible for copyright -- simple text/geometric mark) sourced from npb.jp. No guessed CDN
// patterns and no unverified third-party logo repositories were used.
export const LEAGUE_LOGOS = {
  MLB: "https://www.mlbstatic.com/team-logos/league-on-dark/1.svg",
  NPB: "https://upload.wikimedia.org/wikipedia/commons/7/7f/NPB_logo.svg",
  LMB: "https://lmb.com.mx/images/logo.png",
  CPB: "https://www.cpbl.com.tw/theme/common/images/project/logo_new.png",
  LMP: "https://www.lmp.mx/assets/img/home2/logo_lmp.png",
  KBO: "https://6ptotvmi5753.edge.naverncp.com/KBO_IMAGE/KBOHome/resources/images/common/h1_logo.png",
  NFL: "https://upload.wikimedia.org/wikipedia/en/a/a2/National_Football_League_logo.svg",
  NBA: "https://a.espncdn.com/i/teamlogos/leagues/500/nba.png",
};
